'use strict';

var _ = require('lodash');
var Assign = require('object-assign');

var create = function create(actionObject, options) {
    var actionWrapper = {};

    //loop through object definitions...
    for (var propName in actionObject) {

        if (_.isFunction(actionObject[propName])) {
            //if it is a function, don't apply any 'wrapping'
            actionWrapper[propName] = actionObject[propName];
        } else {
            actionWrapper[propName] = createWrapper(propName, actionObject[propName], actionWrapper, options);
        }
    }

    return actionWrapper;
};

var createWrapper = function createWrapper(propName, actionOptions, actionWrapper, options) {
    return function () {
        var args = arguments;
        return actionOptions.action.apply(actionWrapper, args).then(createSuccess(options.dispatcher, actionOptions.actionTypeName || propName, actionOptions, actionWrapper)).catch(createFailure(options.dispatcher, propName, actionOptions, actionWrapper, args));
    };
};

var createSuccess = function createSuccess(dispatcher, actionTypeName, actionOptions, actionWrapper) {

    if (actionOptions.success) {
        //custom success handler
        return function (payload) {
            return actionOptions.success.call(actionWrapper, payload, dispatcher);
        };
    } else {
        //default success
        return function (objectToMergeWithDispatch) {
            var actionPayload = {
                actionType: actionTypeName + "_SUCCESS"
            };
            //Replaced _.merge(because in v4.2.0 this function loses object types when merged) with Assign
            //dispatcher.dispatch(_.merge(actionPayload, objectToMergeWithDispatch));
            dispatcher.dispatch(Assign(actionPayload, objectToMergeWithDispatch));
            return true;
        };
    }
};

var createFailure = function createFailure(dispatcher, actionName, actionOptions, actionWrapper, args) {

    if (actionOptions.failure) {
        //custom failure
        return function (payload) {
            return actionOptions.failure.call(actionWrapper, payload, dispatcher);
        };
    } else {

        //default failure
        return function (objectToMergeWithDispatch) {
            //todo: log error here instead of console.log (logger may just dump to console during LOCAL and DEV)

            var actionPayload = {
                actionType: (actionOptions.actionTypeName || actionName) + "_FAILURE",
                retryAction: function retryAction() {
                    return actionWrapper[actionName].apply(actionWrapper, args);
                }
            };
            //Replaced _.merge(because in v4.2.0 this function loses object types when merged) with Assign
            //dispatcher.dispatch(_.merge(actionPayload, objectToMergeWithDispatch));
            dispatcher.dispatch(Assign(actionPayload, objectToMergeWithDispatch));
            return false;
        };
    }
};

module.exports = {
    create: create
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/Action.js
// module id = 842
// module chunks = 0